export default __webpack_public_path__ + "static/faith-in-nature-c9dc7ccbe13d20b86cff5e21eb85e017.png";